import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

export default async ({ Vue, redirect, store, router }) => {
  if (process.env.ENV === "dev" || process.env.ENV === "testing") {
    return;
  }

  const options = {
    Vue,
    dsn: process.env.SENTRY_DNS,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [process.env.ENV, process.env.SENTRY_APP_HOST, /^\//],
      }),
    ],
    environment: process.env.ENV,
  };

  if (process.env.ENV === "production") {
    options.tracesSampleRate = 1.0;
  }

  Sentry.init(options);
};
